// user.js
// Returns the adblock userid, if known
function getUserId() {
    var _userIdOptions = [
        (document.location.search.match(/(?:[?&])u=([a-zA-Z0-9]+)/) || {})[1],
        typeof adblock_userid !== "undefined" ? adblock_userid : undefined,
        (document.getElementById("adblock_user_id") || {}).innerText,
        "",
    ];
    // Use the first one that has a value.
    return _userIdOptions.filter(function (o) {
        return o !== undefined;
    })[0];
}

// Returns the adblock userid if exists, else return unknown
function getUserIdOrUnknown() {
    var userId = getUserId();
    return userId === "" ? "unknown" : userId;
}

// Returns the adblock premium userid, if known
function getPremiumUserId() {
    var _userIdOptions = [
        (document.location.search.match(/(?:[?&])u=([a-zA-Z0-9]+)/) || {})[1],
        typeof adblock_premium_userid !== "undefined" ? adblock_premium_userid : undefined,
        (document.getElementById("adblock_premium_user_id") || {}).innerText,
        "",
    ];
    // Use the first one that has a value.
    return _userIdOptions.filter(function (o) {
        return o !== undefined;
    })[0];
}

// Returns the adblock userid if exists, else return unknown
function getPremiumUserIdOrUnknown() {
    var userId = getPremiumUserId();
    return userId === "" ? "unknown" : userId;
}

function getCountryCode() {
    var _geoOptions = [
        (document.location.search.match(/(?:[?&])geo=([a-zA-Z0-9]+)/) || {})[1],
        typeof adblockGeo === "object" && typeof adblockGeo.countryCode === "string"
            ? adblockGeo.countryCode
            : "unknown",
        "unknown",
    ];
    return _geoOptions.filter(function (o) {
        return o !== undefined;
    })[0];
}

function getLanguage() {
    var lan = (document.location.search.match(/(?:[?&])lang=([a-zA-Z0-9_]+)/) || {})[1];
    if (!lan) {
        lan = getLanguageInPath();
    }
    if (!lan) {
        lan = window.navigator.userLanguage || window.navigator.language || "";
    }
    return lan;
}

function getLanguageQueryString() {
    var lan = (document.location.search.match(/(?:[?&])lang=([a-zA-Z0-9_]+)/) || {})[1];
    if (lan === undefined) {
        return "";
    }
    return lan;
}

function getLanguageInPath() {
    const firstPath = window.location.pathname.split("/")[1];
    try {
        Intl.getCanonicalLocales(firstPath.replace("_", "-"));
    } catch (error) {
        return "";
    }
    return firstPath;
}

function getTwoLetterLocale() {
    var lan = getLanguage();
    return lan.slice(0, 2);
}

// Returns "SI" if /installed, "SY" if /pay, "SG" if /, and "SU" for unknown
function getSource() {
    return "S" + getPlainSource();
}

function getPlainSource() {
    const routeToSource = {
        "/purchase/": "VY",
    };
    return routeToSource[location.pathname] || "U"; // default is "U" = unknown
}

function isEnglish() {
    var lan = window.navigator.userLanguage || window.navigator.language;
    var nonEnglish = lan.slice(0, 2) !== "en";
    if (nonEnglish) {
        return false;
    }
    return true;
}

function isIOS() {
    if (
        navigator.userAgent.indexOf("iPhone") != -1 ||
        navigator.userAgent.indexOf("iPad") != -1 ||
        navigator.userAgent.indexOf("iPod") != -1
    ) {
        return true;
    }
    return false;
}

function getOSSingleChar() {
    var a = "U";
    if (-1 != navigator.appVersion.indexOf("Win")) {
        a = "W";
    } else if (isIOS()) {
        a = "I";
    } else if (-1 != navigator.appVersion.indexOf("Mac")) {
        a = "M";
    } else if (-1 != navigator.appVersion.indexOf("X11")) {
        a = "L";
    } else if (-1 != navigator.appVersion.indexOf("Linux")) {
        a = "L";
    }
    return a;
}

// Returns OS from navigator object
function getOS() {
    return "O" + getOSSingleChar();
}

function getOSVersion() {
    var forcedOSVersion = (document.location.search.match(/(?:[?&])ov=([0-9_]+)/) || {})[1];
    if (typeof forcedOSVersion !== "undefined") {
        return forcedOSVersion;
    }
    var match = navigator.userAgent.match(/(CrOS\ \w+|Windows\ NT|Mac\ OS\ X|Linux)\ ([\d\._]+)?/);
    return (match || [])[2] || "unknown";
}

function getBrowser() {
    var a = "U";
    var forcedBrowser = (document.location.search.match(/(?:[?&])bro=([A-Z])/) || {})[1];
    if (forcedBrowser !== undefined) {
        return forcedBrowser;
    }

    var chrome = navigator.userAgent.indexOf("Chrome");
    var opera = navigator.userAgent.indexOf("OPR");
    var edg = navigator.userAgent.indexOf("Edg");
    var edge = navigator.userAgent.indexOf("Edge");
    var safari = navigator.userAgent.indexOf("Safari");
    var firefox = navigator.userAgent.indexOf("Firefox");
    var samsung = navigator.userAgent.indexOf("Samsung");
    var trident = navigator.userAgent.indexOf("Trident");
    if (chrome !== -1 && opera === -1 && samsung === -1 && edg === -1 && edge === -1) {
        a = "E";
    } else if (safari !== -1 && opera === -1 && samsung === -1 && edg === -1 && edge === -1) {
        a = "S";
    } else if (firefox !== -1) {
        a = "F";
    } else if (opera !== -1) {
        a = "O";
    } else if (edge !== -1) {
        a = "M";
    } else if (edg !== -1) {
        a = "CM";
    } else if (navigator.appName === "Microsoft Internet Explorer") {
        a = "T";
    } else if (trident !== -1) {
        a = "T";
    } else if (samsung !== -1) {
        a = "G";
    }
    return a;
}

// Builds tracking information
// TODO name this something better
function recordTracking() {
    var x = "0";
    var g = "0";
    if (typeof _experiment !== "undefined" && _experiment.isExperimentRunning("*")) {
        x = _experiment.xNumber("*");
        g = _experiment.variantIndex("*") + 1;
    }
    var a = getUserId(),
        a = a == "" ? "NA" : a; // set NA if userid isn't set
    return "VP X" + x + "G" + g + " F" + getBrowser() + getOS() + getSource() + " " + a; // return tracking string
}

function getGAID() {
    if (typeof ga !== "undefined" && typeof ga.getByName === "function") {
        var tracker = ga.getByName("gatracker");
        if (tracker !== null) {
            return tracker.get("clientId");
        }
        return "";
    }
    return "";
}

function getPurchaseMetadata(flavor, testMode) {
    var string = "";
    if (typeof _experiment !== "undefined") {
        string =
            "E=" +
            _experiment.name(flavor) +
            "EI=" +
            _experiment.experimentId(flavor) +
            "V=" +
            _experiment.variant(flavor) +
            "VI=" +
            _experiment.variantIndex(flavor);
    } else {
        string = "E=EI=V=VI=";
    }

    if (typeof getUserId === "function") {
        string = string + "U=" + getUserId();
    } else {
        string = string + "U=";
    }

    string = string + "G=" + getGAID();
    string = string + "L=" + getLanguage();
    string = string + "C=" + getCountryCode();
    string = string + "P=" + (typeof isPremium === "function" ? (isPremium() ? "true" : "false") : "false");
    string = string + "CID=" + (typeof getPremiumCid === "function" ? getPremiumCid() : "0");
    string = string + "SID=" + (typeof getPremiumSid === "function" ? getPremiumSid() : "0");
    return string;
}

// log.js
const getLastURL = () => {
    // getLastURL returns last window.location.pathname visited by user or "".
    let result = "";
    if (localStorage && typeof localStorage.getItem === "function") {
        result = localStorage.getItem("lastURL");
    }
    return result;
};

const getLastDataLogmeParams = () => {
    // getLastDataLogmeParams returns last button click logme params or "".
    let result = "";
    if (localStorage && typeof localStorage.getItem === "function") {
        result = localStorage.getItem("lastDataLogmeParams");
    }
    return result;
};

const baseParams = () => {
    const payload = {
        exp: 0,
        var: 0,
        path: window.location.pathname,
        host: window.location.hostname,
        query: window.location.search,
        os: getOSSingleChar(),
        flavor: getBrowser(),
        country: getCountryCode(),
        locale: getLanguage(),
        short_locale: getTwoLetterLocale(),
    };
    if (typeof _experiment !== "undefined" && _experiment.isExperimentRunning("*")) {
        payload["exp"] = _experiment.xNumber("*");
        payload["var"] = _experiment.variantIndex("*") + 1;
    }
    return payload;
};

const logPageView = (withLastURL = false) => {
    try {
        // error boundary
        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");
        let payload = {
            event_name: "pageview",
            ...baseParams(),
        };
        if (withLastURL === true) {
            payload["lastURL"] = getLastURL();
        }
        var raw = JSON.stringify({
            event: "accounts-event",
            payload: payload,
        });
        var requestOptions = {
            method: "POST",
            headers: myHeaders,
            body: raw,
            redirect: "follow",
        };
        fetch("https://log.adblock.dev/v2/accounts/record_log", requestOptions)
            // .then((response) => response.text())
            // .then((result) => console.log(result))
            .catch((error) => console.log("logging error", error));
    } catch (err) {
        console.error("error constructing or sending log:", err);
    }
};

const logButtonClick = async (extraPayload, resolver = () => null) => {
    return new Promise(async function (resolve, reject) {
        try {
            // error boundary
            var myHeaders = new Headers();
            myHeaders.append("Content-Type", "application/json");
            var raw = JSON.stringify({
                event: "accounts-event",
                payload: {
                    event_name: "click",
                    path: window.location.pathname,
                    host: window.location.hostname,
                    ...baseParams(),
                    ...extraPayload,
                },
            });
            var requestOptions = {
                method: "POST",
                headers: myHeaders,
                body: raw,
                redirect: "follow",
            };
            return (
                fetch("https://log.adblock.dev/v2/accounts/record_log", requestOptions)
                    // .then((response) => response.text())
                    .then((result) => {
                        resolver();
                        resolve(result);
                    })
                    .catch((error) => reject(error))
            );
        } catch (err) {
            reject(err);
        }
    });
};

const logVPNExitSurvey = async (extraPayload, resolver = () => null) => {
    return new Promise(async function (resolve, reject) {
        try {
            // error boundary
            var myHeaders = new Headers();
            myHeaders.append("Content-Type", "application/json");
            var raw = JSON.stringify({
                event: "accounts-event",
                payload: {
                    event_name: "vpn_exit_survey",
                    path: window.location.pathname,
                    host: window.location.hostname,
                    ...baseParams(),
                    ...extraPayload,
                },
            });
            var requestOptions = {
                method: "POST",
                headers: myHeaders,
                body: raw,
                redirect: "follow",
            };
            return (
                fetch("https://log.adblock.dev/v2/accounts/record_log", requestOptions)
                    // .then((response) => response.text())
                    .then((result) => {
                        resolver();
                        resolve(result);
                    })
                    .catch((error) => reject(error))
            );
        } catch (err) {
            reject(err);
        }
    });
};

var logThenRedirect = function (redirectURL, extraParams) {
    if (window.Promise) {
        // Don't make promises we can't keep
        var logCallback = new Promise(function (resolve) {
            logButtonClick(extraParams, function () {
                resolve();
            });
        });
        var maxWait = new Promise(function (resolve) {
            setTimeout(function () {
                resolve();
            }, 500);
        });
        // Whichever [resolves first], then redirect
        Promise.race([logCallback, maxWait]).then(function () {
            window.location.href = redirectURL;
        });
    } else {
        logButtonClick(extraParams);
        setTimeout(function () {
            window.location.href = redirectURL;
        }, 500);
    }
};

const logParamsFromElement = (el) => {
    /*
    For every attribute prefixed by "logparam_", extract that log parameter
    and its value as a key-value pair and return the object. Any "_" after
    the first is included. Example, this @el
    <a href="/foo" data-logme data-logparam_location="bottom" data-logparam_btn_type="cta">link</a>
    will returtn {"location": "bottom", "btn_type": cta}
    */
    if (!el) {
        return {};
    }
    const extras = Object.assign({}, $(el)[0].dataset);
    const logVals = Object.fromEntries(
        Object.entries(extras)
            .filter((e) => e[0].slice(0, 9) === "logparam_")
            .map((e) => [e[0].split("_").slice(1).join("_"), extras[e[0]]])
    );
    return logVals;
};

const logPaymentButtonClick = (extraParams) => {
    const params = {};
    Object.assign(params, extraParams);
    params["btn_type"] = "purchase";
    params["last_url"] = getLastURL();
    params["last_logme_params"] = getLastDataLogmeParams();
    logButtonClick(params);
};

module.exports = { logButtonClick, logVPNExitSurvey };
